const answerResponse = {
  Unset: 0,
  Si: 146,
  No: 147,
  NA: 148,
};

export default answerResponse;
